import script from "./DepositAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositAdmin.vue?vue&type=script&setup=true&lang=js"

import "./DepositAdmin.vue?vue&type=style&index=0&id=17c1ac52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c1ac52"]])

export default __exports__